import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';

import { closeModal } from 'features/utilsSlice';
import useModalOpen from 'hooks/useModalOpen';
import useModalData from 'hooks/useModalData';
import AdditionalInfo from './gigSetup/AdditionalInfo';
import TransitionDialog from 'components/TransitionDialog';
import styles from 'styles/components/CenteredDialog.module.scss';

const useStyles = makeStyles(theme => ({
  paper: {
    height: 'fit-content',
    width: '90%',
    marginBottom: 'auto',
    top: '15%',
    borderRadius: 10,

    [theme.breakpoints.up('md')]: {
      width: '50%',
    },

    [theme.breakpoints.up('lg')]: {
      width: '30%',
    },
  },

  paperFullScreenDialog: {
    width: '100%',
  },
}));

const height = { height: 40 };

const SimpleDialog = ({ modalName, description, onClick, buttonText }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const open = useModalOpen(modalName);

  const { info } = useModalData(modalName);
  const { modalDescription } = useModalData(modalName);

  const handleClose = () => dispatch(closeModal(modalName));

  const handleClick = () => {
    if (onClick) onClick();

    handleClose();
  };

  return (
    <TransitionDialog
      open={open}
      handleClose={handleClose}
      paperProps={{ className: classes.paper }}
      dialogStyles={classes.paperFullScreenDialog}
      direction="up"
      desktopDirection="up"
      noCloseIcon
    >
      <div className={styles.container}>
        {info ? (
          <AdditionalInfo
            shoutoutText={info?.shoutoutText}
            shoutoutEg={info?.shoutoutEg}
            brandText={info?.brandText}
            brandEg={info?.brandEg}
            margin={'0px'}
          />
        ) : (
          <>
            <h4 style={modalDescription ? { margin: 0, fontSize: 14, opacity: 0.9 } : {}}>
              {modalDescription ? modalDescription : description}
            </h4>

            {buttonText && (
              <Button
                color="primary"
                variant="contained"
                onClick={handleClick}
                style={height}
                fullWidth
              >
                {buttonText}
              </Button>
            )}
          </>
        )}
      </div>
    </TransitionDialog>
  );
};

SimpleDialog.propTypes = {
  modalName: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  buttonText: PropTypes.string,
};

SimpleDialog.defaultProps = {
  description: '' || {},
  buttonText: '',
};

export default SimpleDialog;
